export const DEFAULT_RECRUITMENT_STAGES = [
  { key: 'applied', label: 'Applied', order: 1, isTerminal: false },
  { key: 'resume_screening', label: 'Resume Screening', order: 2, isTerminal: false },
  { key: 'shortlisted', label: 'Shortlisted', order: 3, isTerminal: false },
  { key: 'interview_scheduled', label: 'Interview Scheduled', order: 4, isTerminal: false },
  { key: 'interview_completed', label: 'Interview Completed', order: 5, isTerminal: false },
  { key: 'selected', label: 'Selected', order: 6, isTerminal: false },
  { key: 'offered', label: 'Offered', order: 7, isTerminal: false },
  { key: 'onboarding', label: 'Onboarding', order: 8, isTerminal: false },
  { key: 'hired', label: 'Hired', order: 9, isTerminal: true },
  { key: 'rejected', label: 'Rejected', order: 98, isTerminal: true },
  { key: 'on_hold', label: 'On Hold', order: 99, isTerminal: false },
];